import {
  hiddenFormField,
  BelongsToReferenceField,
  dataSourcePrimaryKeys,
  SystemPrivateFields,
} from 'drapcode-constant';

export const TenantFields = ['tenantId'];
export const UserSettingsFields = ['userSettingId'];
export const SubTenantFields = ['subTenantId'];
export const OTPFields = [
  'emailOtp',
  'emailOtpExpiry',
  'emailOtpToken',
  'emailConsentBy',
  'emailConsentAt',
  'smsOtp',
  'smsOtpExpiry',
  'smsOtpToken',
  'smsConsentBy',
  'smsConsentAt',
];

export const filterFieldsForForm = (fields) => {
  return fields.filter((field) => {
    return (
      !hiddenFormField.includes(field.type) &&
      !dataSourcePrimaryKeys.includes(field.fieldName) &&
      !TenantFields.includes(field.fieldName) &&
      !UserSettingsFields.includes(field.fieldName) &&
      !SubTenantFields.includes(field.fieldName) &&
      !OTPFields.includes(field.fieldName)
    );
  });
};
export const filterFieldsForDataSearchForm = (fields) => {
  return fields.filter((field) => {
    return (
      !SystemPrivateFields.includes(field.type) &&
      !dataSourcePrimaryKeys.includes(field.fieldName) &&
      !TenantFields.includes(field.fieldName) &&
      !UserSettingsFields.includes(field.fieldName) &&
      !SubTenantFields.includes(field.fieldName) &&
      !OTPFields.includes(field.fieldName)
    );
  });
};
export const filterFieldsForDataTable = (fields) => {
  return fields.filter((field) => {
    return (
      field.type !== 'utility' &&
      !hiddenFormField.includes(field.type) &&
      !BelongsToReferenceField.includes(field.type) &&
      !TenantFields.includes(field.id) &&
      !UserSettingsFields.includes(field.id) &&
      !SubTenantFields.includes(field.id) &&
      !OTPFields.includes(field.id) &&
      field.id !== ''
    );
  });
};

export const filterFieldsForTypesenseCollection = (fields, typesenseCollection) => {
  const { typesenseMapping = [] } = typesenseCollection;
  const mappedFieldNames = typesenseMapping.map((mapping) => mapping.fieldName);
  const filteredFields = fields.filter((field) => mappedFieldNames.includes(field.id));
  return filteredFields;
};
